<template>
   <div class="row">
      <div class="col-md-12">
         <div class="form-inline" v-if="meta.is_active">
            <label class="mr-2">Filter Table</label>
            <select
               class="form-control"
               v-model="meta.is_active"
               @change="loadIsActive"
            >
               <option value="2">Show All</option>
               <option value="1">Show Only Active</option>
               <option value="0">Show Only Inactive</option>
            </select>
         </div>
         <div class="clearfix"><br /></div>
      </div>
      <div class="col-md-4 mb-2">
         <div class="form-inline">
            <label class="mr-2">Showing</label>
            <select
               class="form-control"
               v-model="meta.per_page"
               @change="loadPerPage"
            >
               <option value="10">10</option>
               <option value="25">25</option>
               <option value="50">50</option>
               <option value="100">100</option>
            </select>
            <label class="ml-2">Entries</label>
         </div>
      </div>

      <div class="col-md-4 offset-md-4">
         <!-- SEARCH BY DATE -->
         <div class="form-inline float-right" v-if="is_search_by_date">
            <label class="mr-2">Search by Date</label>
            <input type="date" class="form-control" @input="search" />
         </div>
         <!-- SEARCH DEFAULT -->
         <div class="form-inline float-right mb-3" v-else>
            <label class="mr-2 ">Search</label>
            <input type="text" class="form-control " @input="search" />
         </div>
      </div>

      <div class="col-md-12">
         <CDataTable
            sorter
            striped
            hover
            bordered
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            show-empty
         >
            <template #is_active="{item}">
               <td>
                  <CBadge v-if="item.is_active == 0" color="danger">No</CBadge>
                  <CBadge v-if="item.is_active == 1" color="success"
                     >Yes</CBadge
                  >
               </td>
            </template>
            <template #is_publish="{item}">
               <td v-if="item.is_publish == '1'">{{ "Public" }}</td>
               <td v-else>{{ "Private" }}</td>
            </template>
            <template #type="{item}">
               <td v-if="item.type == '1'">{{ "Singleclass" }}</td>
               <td v-else>{{ "Multiclass" }}</td>
            </template>
            <template #action="{item}" v-if="meta.is_active">
               <td v-if="item.is_active == 1" style="width:250px">
                  <CDropdown
                     placement="bottom-end"
                     :offset="[-70, -35]"
                     toggler-text="Action"
                     color="primary"
                     class="m-2 d-inline-block"
                     size="sm"
                  >
                     <CDropdownItem
                        @click="is_uuid ? show(item.uuid) : show(item.id)"
                        >Detail Class Template</CDropdownItem
                     >
                     <CDropdownItem
                        @click="is_uuid ? edit(item.uuid) : edit(item.id)"
                        >Edit Class Template</CDropdownItem
                     >
                     <CDropdownItem
                        @click="is_uuid ? destroy(item.uuid) : destroy(item.id)"
                        >Delete Class Template</CDropdownItem
                     >
                     <CDropdownItem
                        @click=" show_attendance(item.id)"
                        >Show Participant</CDropdownItem
                     >
                     <CDropdownItem
                        v-if="item.is_active == 1"
                        @click="
                           is_uuid ? deactivate(item.uuid) : deactivate(item.id)
                        "
                        >Deactivate</CDropdownItem
                     >
                     <CDropdownItem
                        v-if="item.is_active == 0"
                        @click="
                           is_uuid ? reactivate(item.uuid) : reactivate(item.id)
                        "
                        >Reactivate</CDropdownItem
                     >
                  </CDropdown>
               </td>
               <td v-else style="width:250px">
                  <CButton
                     size="sm"
                     variant="primary"
                     color="warning"
                     @click="
                        is_uuid ? reactivate(item.uuid) : reactivate(item.id)
                     "
                     >Reactivate</CButton
                  >
               </td>
            </template>
         </CDataTable>
      </div>

      <div class="col-md-6">
         <p>
            Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items
         </p>
      </div>

      <div class="col-md-6">
         <b-pagination
            v-model="meta.current_page"
            :total-rows="meta.total"
            :per-page="meta.per_page"
            align="right"
            @change="changePage"
            aria-controls="dw-datatable"
         ></b-pagination>
      </div>
   </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import service from "@/services/service";
import section from "@/services/section";

export default {
   name: "Table",
   props: {
      items: Array,
      caption: {
         type: String,
         default: "Table",
      },
      hover: Boolean,
      striped: Boolean,
      bordered: Boolean,
      small: Boolean,
      fixed: Boolean,
      dark: Boolean,
      items: {
         type: Array,
         required: true,
      },
      fields: {
         type: Array,
         required: true,
      },
      meta: {
         required: true,
      },
      btn_show: {
         required: true,
      },
      btn_edit: {
         required: true,
      },
      btn_edit_birthday: {
         required: true,
      },
      btn_deactivate: {
         required: true,
      },
      btn_reactivate: {
         required: true,
      },
      btn_destroy: {
         required: true,
      },
      is_uuid: {
         required: true,
      },
      is_search_by_date: {
         required: true,
      },
   },
   data() {
      return {
         sortBy: null,
         sortDesc: false,
         deleteModal: false,
         selected: null,
         selectID: null,
         inc: 5,
      };
   },
   watch: {
      sortBy(val) {
         this.$emit("sort", {
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
         });
      },
      sortDesc(val) {
         this.$emit("sort", {
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
         });
      },
   },
   methods: {
      loadPerPage(val) {
         this.$emit("per_page", this.meta.per_page);
      },

      loadIsActive(val) {
         this.$emit("is_active", this.meta.is_active);
      },

      changePage(val) {
         this.$emit("pagination", val);
      },

      search: _.debounce(function(e) {
         this.$emit("search", e.target.value);
      }, 500),

      show: function(id) {
         this.$emit("show", id);
      },

      edit: function(id) {
         this.$emit("edit", id);
      },

      edit_birthday: function(id) {
         this.$emit("editbirthday", id);
      },

      deactivate: function(id) {
         this.$emit("deactivate", id);
      },

      reactivate: function(id) {
         this.$emit("reactivate", id);
      },
      
      show_attendance: function(id) {
         this.$emit("show_attendance", id);
      },
      destroy: function(id) {
         this.$emit("destroy", id);
      },

      resetpassword: function(id) {
         this.$emit("resetpassword", id);
      },

      grantwebaccess: function(id) {
         this.$emit("grantwebaccess", id);
      },

      converttomember: function(id) {
         this.$emit("converttomember", id);
      },

      frontEndDateFormat: function(date) {
         return moment(date, "YYYY-MM-DD").format("DD MMMM YYYY");
      },
   },
};
</script>
